export const teamMembers = [
  {
    name: 'Arne Mallmann',
    role: 'Operation & Sales',
    bio: 'Begleitet Flächenakquise und Projektentwicklung mit Fokus auf pragmatische Standortlösungen.',
    image: '/assets/team-arne-mallmann.jpeg',
    imageWidth: 984,
    imageHeight: 1416,
  },
  {
    name: 'Michael Doerdrechter',
    role: 'Operations & Sales',
    bio: 'Verbindet operative Projektstruktur mit vertriebsnaher Beratung für Eigentümer und Partner.',
    image: '/assets/team-michael-doerdrechter.jpeg',
    imageWidth: 1366,
    imageHeight: 2048,
  },
  {
    name: 'Lee-Ann Sophie Klein',
    role: 'Geschäftsführerin',
    bio: 'Steuert Unternehmensentwicklung, Partnerschaften und die professionelle Weiterentwicklung der EN:POWER-Struktur.',
    image: '/assets/team-lee-ann-klein.png',
    imageWidth: 1023,
    imageHeight: 1537,
  },
  {
    name: 'Randy Wesley Kirsten',
    role: 'Geschäftsführer',
    bio: 'Verantwortet Strategie, Projektpipeline und den Ausbau langfristiger Energieprojekte.',
    image: '/assets/team-randy-kirsten.png',
    imageWidth: 1023,
    imageHeight: 1538,
  },
  {
    name: 'Kilian Elitzke',
    role: 'Sales',
    bio: 'Qualifiziert Flächenpotenziale und führt Interessenten durch die ersten Projektschritte.',
    image: '/assets/team-kilian-elitzke-2026-06-01.jpeg',
    imageWidth: 1086,
    imageHeight: 1448,
  },
  {
    name: 'Lennart Laabs',
    role: 'Marketing',
    bio: 'Sorgt für klare Kommunikation, Markenauftritt und verständliche Projektinformationen.',
    image: '/assets/team-lennart-laabs.jpg',
    imageWidth: 1000,
    imageHeight: 1500,
  },
  {
    name: 'Lukas Müller',
    role: 'Sales',
    bio: 'Unterstützt Eigentümer in der Erstbewertung und strukturiert passende nächste Schritte.',
    image: '/assets/team-lukas-mueller.jpg',
    imageWidth: 1000,
    imageHeight: 1500,
  },
];
